import { marked } from 'marked';
import DOMPurify from 'dompurify';

export function markdownToHtml(md) {
  if (!md) return '';
  return DOMPurify.sanitize(marked.parse(md));
}
